<template>
    <th style="" v-if="sortable">
        <a class="btn-sort" :class="sorting_class" @click="$parent.sort(sort)">{{ display }}
            <i class="fas" :class="[ current_sort == sort ? icon : 'fa-sort' ]"></i>
        </a>
    </th>
    <th v-else>
        <a disabled>{{ display ? display : '#' }}</a>
    </th>
</template>

<script>
    export default {
        name: "SortHeader",

        props: {
            sortable: {
                type: Boolean,
                default: true,
            },
            sort: {
                type: String,
            },
            display: {
                type: String,
                default: '',
            }
        },

        computed: {
            icon() {
                return this.current_order == 'desc' ? 'fa-sort-down' : 'fa-sort-up';
            },
            current_sort() {
                // return this.$store.state.filters.sort;

                if(!_.isNil(this.$store.state.unique_page_id) && !_.isEmpty(this.$store.state.unique_page_id)){
                    return this.$store.state.filters[(this.$store.state.unique_page_id + '_sort')];
                }
                else{
                    return this.$store.state.filters.sort;
                }
            },
            current_order() {
                // return this.$store.state.filters.order;

                if(!_.isNil(this.$store.state.unique_page_id) && !_.isEmpty(this.$store.state.unique_page_id)){
                    return this.$store.state.filters[(this.$store.state.unique_page_id + '_order')];
                }
                else{
                    return this.$store.state.filters.order;
                }
            },
            sorting_class() {
                return this.current_sort == this.sort ? this.current_order : '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Table/SortHeader.vue